import { Component, OnInit, Input } from "@angular/core";
import { AlertController, LoadingController, ToastController } from "@ionic/angular";
import { SharedService } from "src/app/core-files/shared.service.";
import { LoadingComponent } from "src/app/core-files/loaders/Loader";
import { SidebarService } from "src/app/services/sidebar.service";
import { ToastComponent } from "src/app/core-files/loaders/toast-messages";

@Component({
  selector: "app-invitations",
  templateUrl: "./invitations.component.html",
  styleUrls: ["./invitations.component.scss"],
  standalone: false
})
export class InvitationsComponent implements OnInit {
  @Input() i;
  @Input() isCheck: boolean;
  modifiedTimestamp;
  constructor(
    private sidebarService: SidebarService,
    public alertController: AlertController,
    private sharedService: SharedService,
    private loadingController: LoadingController,
    public toastController: ToastController,
    private toastComponent: ToastComponent
  ) {

  }

  ngOnInit() {
   
  }

  Iamthere(id, isResponse) {
    if (isResponse) {
      this.presentAlertConfirm();
   } else {
      this.sidebarService
        .SaveInvitationResponse(id, 1)
        .subscribe(res => {
          this.toastComponent.showToast('Invitaion response send successfully.', 'success');
          this.sharedService.setInvitaionRespo(true);
        });
    }

  }
  Maybe(id, isResponse) {

      if (isResponse) {
         this.presentAlertConfirm();
      } else {
        this.sidebarService
          .SaveInvitationResponse(id, 2)
          .subscribe(res => {
            this.toastComponent.showToast('Invitaion response send successfully.', 'success');
            this.sharedService.setInvitaionRespo(true);
          });
      }
  }
  Sorry(id, isResponse) {

      if (isResponse) {
         this.presentAlertConfirm();
      } else {
        this.sidebarService
          .SaveInvitationResponse(id, 3)
          .subscribe(res => {
            this.toastComponent.showToast('Invitaion response send successfully.', 'success');
            this.sharedService.setInvitaionRespo(true);
          });
      }
  }
  myDateParser(dateStr: string): string {

    let date = dateStr.substring(0, 10);
    let time = dateStr.substring(11, 19);
    let millisecond = dateStr.substring(20)

    let validDate = date + 'T' + time + '.' + millisecond;
    return validDate
  }
  async DeleteInvitations(id) {
 

    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Confirm!",
      message: "<strong>Are you sure?</strong>",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: blah => {
            
          }
        },
        {
          text: "Delete",
          handler: async () => {
             const loading = await this.loadingController.create({
              cssClass: "my-custom-class",
              message: "Please Wait...",
            });
            (await loading.present());
            this.sidebarService.DeleteInvitations(id).subscribe(async res => {
              
              (await loading.dismiss());
              this.sharedService.setIsShortlistDelete(true);
              const toast = await this.toastController.create({
                message: "Delete Successfully",
                position: "top",
                duration: 2000,
                color: "success"
              });
              toast.present();
            }),
              async error => {
                (await loading.dismiss());
                const toast = await this.toastController.create({
                  message: "try again",
                  position: "top",
                  duration: 2000,
                  color: "danger"
                });
                toast.present();
              };
          }
        }
      ]
    });
    await alert.present();
  }

  async presentAlertConfirm() {
    const alert = await this.alertController.create({
      cssClass: 'inv-alert',
      header: 'Response Already Sent',
      subHeader: 'No changes needed',
      message: 'You have already submitted your response for this invitation. Thank you for your reply!',
      buttons: [
        {
          text: 'Got It',
          role: 'cancel',
          cssClass: 'inv-alert-btn-primary'
        }
      ]
    });

    await alert.present();
  }
}
